import Chat from "@/libs/chat/chat";
import store from "@/store"

let organizationId = store.state.user.organization.id;
let chatMap = {};
chatMap[organizationId] = {};

store.watch(
    (state) => {
        return state.user.organization;
    },
    () => {
        organizationId = store.state.user.organization.id;
        if (!chatMap.hasOwnProperty(organizationId)) {
            chatMap[organizationId] = {};
        }
    }
)

export default function (id) {
    // if (chatMap[organizationId][id]) {
    //     return chatMap[organizationId][id];
    // }
    // return chatMap[organizationId][id] = new Chat(id);
    return new Chat(id);
};
